import { PinterestIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { Link, useLocation } from 'react-router-dom';
import { useHandleMenuClick } from 'App/hooks';
import {
  PINTEREST_APP_CODE,
  PINTEREST_APP_ID,
} from 'domains/PartnersApps/constants';
import { useNuvemApps } from 'domains/PartnersApps/pages/NuvemAppPage/hooks';
import { menuPrimaryPinterestClick } from './tracking';

const BASE_PATH = '/apps';

const INSTALLED_PATH = `${BASE_PATH}/${PINTEREST_APP_CODE}`;
const AUTHORIZE_PATH = `${BASE_PATH}/${PINTEREST_APP_ID}/authorize`;

function PinterestMenu() {
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();
  const { nuvemApps } = useNuvemApps();
  const isPinterestInstalled = nuvemApps?.[PINTEREST_APP_CODE]?.installed;

  return (
    <MenuButton
      as={Link}
      to={`${isPinterestInstalled ? INSTALLED_PATH : AUTHORIZE_PATH}`}
      startIcon={PinterestIcon}
      onClick={() => {
        menuPrimaryPinterestClick(Boolean(isPinterestInstalled));
        handleClickItem();
      }}
      active={[INSTALLED_PATH, AUTHORIZE_PATH].includes(pathname)}
      label="Pinterest"
    />
  );
}

export default PinterestMenu;
